export default __webpack_public_path__ + "static/media/1774.45caf317.JPG";